var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalObjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63017 10.5165L15.4592 15.8826C15.8045 16.0395 16.195 16.0395 16.5403 15.8826L28.3693 10.5165C29.2097 10.1352 29.2097 8.86513 28.3693 8.48376L16.5408 3.1172C16.3711 3.03965 16.1868 2.99951 16.0002 2.99951C15.8137 2.99951 15.6293 3.03965 15.4597 3.1172L3.63017 8.48325C2.78974 8.86462 2.78974 10.1352 3.63017 10.5165ZM28.3698 14.9995L25.4199 13.6624L17.2116 17.3832C16.8277 17.5574 16.4199 17.6457 16 17.6457C15.58 17.6457 15.1727 17.5574 14.7883 17.3832L6.58056 13.6624L3.63017 14.9995C2.78974 15.3804 2.78974 16.6499 3.63017 17.0308L15.4592 22.3927C15.8045 22.5492 16.195 22.5492 16.5403 22.3927L28.3698 17.0308C29.2102 16.6499 29.2102 15.3804 28.3698 14.9995ZM28.3698 21.4893L25.4311 20.1574L17.2116 23.8832C16.8277 24.0574 16.4199 24.1457 16 24.1457C15.58 24.1457 15.1727 24.0574 14.7883 23.8832L6.56938 20.1574L3.63017 21.4893C2.78974 21.8702 2.78974 23.1397 3.63017 23.5206L15.4592 28.8826C15.8045 29.039 16.195 29.039 16.5403 28.8826L28.3698 23.5206C29.2102 23.1397 29.2102 21.8702 28.3698 21.4893Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "currentColor",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalObjects);
export default __webpack_public_path__ + "static/media/global_objects.92d39896ff3d56920ea790af42be3770.svg";
export { ForwardRef as ReactComponent };